import { b64url, utf8 } from "./b64";

export async function create(): Promise<{ verifier: string; challenge: string }> {
  const verifier = b64url(crypto.getRandomValues(new Uint8Array(32)));
  const challenge = b64url(await crypto.subtle.digest("SHA-256", utf8(verifier)));
  return { verifier, challenge };
}
